import { useEffect } from 'react';
import { vevet, ScrollBar } from '@anton.bobrov/vevet-init';

function useCustomScrollbar() {
  useEffect(() => {
    if (vevet.isMobile) {
      return void 0;
    }
    const instance = new ScrollBar({
      container: window,
      canAutoHide: false
    });
    const { _xBar: xBar, _yBar: yBar } = instance;
    const customClassName = "ui-global-scrollbar";
    xBar.outer?.classList?.add(customClassName);
    yBar.outer?.classList?.add(customClassName);
    return () => instance.destroy();
  }, []);
}

export { useCustomScrollbar };
//# sourceMappingURL=useCustomScrollbar.js.map
